namespace SP {
    export function fixFloatingNumber(number: number): number {
        return parseFloat(number.toPrecision(12));
    }
   
}